import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { listPrograms, upcomingPrograms } from '../../data/programs';
import '../../styles/components/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProgramsOpen, setIsProgramsOpen] = useState(false);
  const programsRef = useRef(null);
  const location = useLocation();

  const programs = listPrograms();

  // Close the Programas dropdown when clicking outside.
  useEffect(() => {
    const handler = (e) => {
      if (programsRef.current && !programsRef.current.contains(e.target)) {
        setIsProgramsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Close dropdown / mobile menu on route change.
  useEffect(() => {
    setIsProgramsOpen(false);
    setIsMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => setIsMenuOpen((v) => !v);

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/" className="logo">
              <img src="/assets/icons/logo.svg" alt="LifeUp" className="logo-image" />
              <span className="logo-text">LifeUp</span>
            </Link>
          </div>

          <nav className="nav-desktop">
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className="nav-link">Início</Link>
              </li>

              <li className="nav-item nav-item--has-menu" ref={programsRef}>
                <button
                  type="button"
                  className="nav-link nav-link--button"
                  aria-expanded={isProgramsOpen}
                  aria-haspopup="true"
                  onClick={() => setIsProgramsOpen((v) => !v)}
                >
                  Programas
                  <ChevronDown size={14} />
                </button>
                {isProgramsOpen && (
                  <div className="nav-dropdown">
                    {programs.map((p) => (
                      <Link key={p.slug} to={`/${p.slug}`} className="nav-dropdown__item">
                        <span
                          className="nav-dropdown__dot"
                          style={{ background: p.colors.primary }}
                        />
                        <div>
                          <strong>{p.name}</strong>
                          <span>{p.tagline}</span>
                        </div>
                      </Link>
                    ))}
                    {upcomingPrograms.length > 0 && (
                      <div className="nav-dropdown__divider" />
                    )}
                    {upcomingPrograms.map((p) => (
                      <div key={p.slug} className="nav-dropdown__item nav-dropdown__item--soon">
                        <span
                          className="nav-dropdown__dot"
                          style={{ background: p.colors.primary }}
                        />
                        <div>
                          <strong>{p.name}</strong>
                          <span>Em breve</span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </li>

              <li className="nav-item">
                <Link to="/sobre" className="nav-link">Sobre</Link>
              </li>
              <li className="nav-item">
                <a href="#features" className="nav-link">Recursos</a>
              </li>
              <li className="nav-item">
                <Link to="/blog" className="nav-link">Blog</Link>
              </li>
              <li className="nav-item">
                <Link to="/contato" className="nav-link">Contato</Link>
              </li>
            </ul>
          </nav>

          <button
            className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Menu"
          >
            <span></span><span></span><span></span>
          </button>
        </div>

        <nav className={`nav-mobile ${isMenuOpen ? 'open' : ''}`}>
          <ul className="nav-mobile-list">
            <li className="nav-mobile-item">
              <Link to="/" className="nav-mobile-link" onClick={toggleMenu}>Início</Link>
            </li>
            {programs.map((p) => (
              <li key={p.slug} className="nav-mobile-item">
                <Link to={`/${p.slug}`} className="nav-mobile-link" onClick={toggleMenu}>
                  <span
                    className="nav-mobile-dot"
                    style={{ background: p.colors.primary }}
                  />
                  {p.name}
                </Link>
              </li>
            ))}
            <li className="nav-mobile-item">
              <Link to="/sobre" className="nav-mobile-link" onClick={toggleMenu}>Sobre</Link>
            </li>
            <li className="nav-mobile-item">
              <a href="#features" className="nav-mobile-link" onClick={toggleMenu}>Recursos</a>
            </li>
            <li className="nav-mobile-item">
              <Link to="/blog" className="nav-mobile-link" onClick={toggleMenu}>Blog</Link>
            </li>
            <li className="nav-mobile-item">
              <Link to="/contato" className="nav-mobile-link" onClick={toggleMenu}>Contato</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
